import { render, staticRenderFns } from "./ProcessingRequests.vue?vue&type=template&id=59ca1411&"
import script from "./ProcessingRequests.vue?vue&type=script&lang=js&"
export * from "./ProcessingRequests.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingRequests.vue?vue&type=style&index=0&id=59ca1411&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports